export default "__VITE_ASSET__oNN$1dJN__"